import { TaskPriority, TaskRecurrence, TaskStatus } from "../Models/Models";
import { Vocabulary } from "./Vocabulary";

export const TASK_VIEW = {
  BOARD: "board",
  TABLE: "table",
} as const;

// Upper bound the backend enforces on perPage (App\Utils\TaskConstants::MAX_PER_PAGE).
// Screens without their own pagination UI (Dashboard, Calendar) pass this to fetch everything in one page.
export const TASKS_MAX_PER_PAGE = 200;

export const TASK_RECURRENCE: Record<string, TaskRecurrence> = {
  DAILY: "daily",
  WEEKLY: "weekly",
  ANNUAL: "annual",
};

export const TASK_PRIORITY_OPTIONS: { value: TaskPriority; label: string }[] =
  [
    { value: "high", label: Vocabulary.taskPriorityHigh },
    { value: "medium", label: Vocabulary.taskPriorityMedium },
    { value: "low", label: Vocabulary.taskPriorityLow },
  ];

export const TASK_STATUS_OPTIONS: { value: TaskStatus; label: string }[] = [
  { value: "not_started", label: Vocabulary.taskStatusNotStarted },
  { value: "in_progress", label: Vocabulary.taskStatusInProgress },
  { value: "completed", label: Vocabulary.taskStatusDone },
];

export const TASK_RECURRENCE_OPTIONS: {
  value: TaskRecurrence;
  label: string;
}[] = [
  { value: "daily", label: Vocabulary.taskPeriodicityDaily },
  { value: "weekly", label: Vocabulary.taskPeriodicityWeekly },
  { value: "annual", label: Vocabulary.taskPeriodicityYearly },
];

export const TASK_PRIORITY_STYLES: Record<
  TaskPriority,
  { label: string; chipClass: string }
> = {
  high: { label: Vocabulary.taskPriorityHigh, chipClass: "priorityHigh" },
  medium: { label: Vocabulary.taskPriorityMedium, chipClass: "priorityMedium" },
  low: { label: Vocabulary.taskPriorityLow, chipClass: "priorityLow" },
};

export const TASK_STATUS_COLUMN_CONFIG: {
  status: TaskStatus;
  label: string;
  color: string;
  accentColor: string;
  badgeColor: string;
  bgColor: string;
}[] = [
  {
    status: "not_started",
    label: Vocabulary.taskStatusNotStarted,
    color: "#6b7280",
    accentColor: "#cbd5e1",
    badgeColor: "#9ca3af",
    bgColor: "#f3f4f6",
  },
  {
    status: "in_progress",
    label: Vocabulary.taskStatusInProgress,
    color: "#2563eb",
    accentColor: "#3b82f6",
    badgeColor: "#2563eb",
    bgColor: "#eff6ff",
  },
  {
    status: "completed",
    label: Vocabulary.taskStatusDone,
    color: "#16a34a",
    accentColor: "#22c55e",
    badgeColor: "#16a34a",
    bgColor: "#f0fdf4",
  },
];

export const TASK_STATUSES = TASK_STATUS_COLUMN_CONFIG.map((c) => c.status);

export const TASK_PROGRESS_COLOR_THRESHOLDS: {
  threshold: number;
  color: string;
}[] = [
  { threshold: 100, color: "#16a34a" },
  { threshold: 60, color: "#FF6633" },
  { threshold: 0, color: "#e74c3c" },
];

export function getProgressColor(progress: number): string {
  return (
    TASK_PROGRESS_COLOR_THRESHOLDS.find((p) => progress >= p.threshold)
      ?.color ?? "#e74c3c"
  );
}
